import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, ListItemButton } from "@mui/material";

export interface Center {
    code: string;
    name: string;
    accessUntil?: string | null;
}

interface AddCenterDialogProps {
    open: boolean;
    centersToAdd: Center[];
    selectedCenter: Center | null;
    onSelect: (center: Center) => void;
    onClose: () => void;
    onAdd: () => void;
}

export const AddCenterDialog: React.FC<AddCenterDialogProps> = ({ open, centersToAdd, selectedCenter, onSelect, onClose, onAdd }) => {
    const sortedCenters = [...centersToAdd].sort((a, b) => a.name.localeCompare(b.name));
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Select a Center to Add</DialogTitle>
            <DialogContent>
                <List>
                    {sortedCenters.length === 0 && (
                        <ListItem>No available centers to add.</ListItem>
                    )}
                    {sortedCenters.map((center) => (
                        <ListItem key={center.code} disablePadding>
                            <ListItemButton
                                selected={selectedCenter?.code === center.code}
                                onClick={() => onSelect(center)}
                            >
                                <ListItemText primary={center.name} secondary={`Code: ${center.code}`} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onAdd} disabled={!selectedCenter} variant="contained">Add</Button>
            </DialogActions>
        </Dialog>
    );
};
